import { render, staticRenderFns } from "./EmployeeFeature.vue?vue&type=template&id=10476a40"
import script from "./EmployeeFeature.vue?vue&type=script&lang=js"
export * from "./EmployeeFeature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports